module.exports = __webpack_public_path__ + "img/Jhaoho_home.b2bff1fa.jpg";